import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../constants/common'
import { useSelection } from '../../../../../hooks'
import { useLocationPagination } from '../../../../Pagination'
import { getIsRentalPortalPageReadCurrent } from '../../../RentalPortal.utils'
import { getRentalPortalArchiveItems } from '../../RentalPortalArchive.api'
import { getRentalPortalArchivePage } from '../../RentalPortalArchive.utils'

export function useRentalPortalArchiveTable() {
  const { pagination: locationPagination, setPagination } =
    useLocationPagination()

  const [reloadKey, setReloadKey] = useState(0)

  const [allItems, setAllItems] = useState(EMPTY_LIST)
  const [serverError, setServerError] = useState(null)

  const [isInitiated, setInitiated] = useState(false)
  const [loadedReloadKey, setLoadedReloadKey] = useState(null)

  const readIdRef = useRef(0)

  const pageScrollWrapperRef = useRef(null)

  const { items, pagination } = getRentalPortalArchivePage({
    allItems,
    page: locationPagination.page,
  })

  const selection = useSelection({ data: { items }, pagination })

  useEffect(() => {
    readIdRef.current += 1

    const readId = readIdRef.current

    getRentalPortalArchiveItems()
      .then(nextItems => {
        if (getIsRentalPortalPageReadCurrent({ readId, readIdRef })) {
          setAllItems(nextItems)
          setServerError(null)

          setLoadedReloadKey(reloadKey)
          setInitiated(true)
        }
      })
      .catch(error => {
        if (getIsRentalPortalPageReadCurrent({ readId, readIdRef })) {
          setServerError(error)

          setLoadedReloadKey(reloadKey)
          setInitiated(true)
        }
      })
  }, [reloadKey])

  async function handleRefresh() {
    selection.handleCleanSelection()

    setReloadKey(prevReloadKey => prevReloadKey + 1)
  }

  return {
    ...selection,
    allItems,
    handleRefresh,
    handleSetPagination: setPagination,
    isLoading: !isInitiated,
    isRefetching: loadedReloadKey !== reloadKey && isInitiated,
    items,
    pageScrollWrapperRef,
    pagination,
    serverError,
  }
}
